var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.926,
    height: 53.099,
    viewBox: "0 0 86.926 53.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-22.852 -38.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2806050136896",
    transform: "translate(0.31 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M446.051,744.629a36.98,36.98,0,0,1,51.376,0l1.7,1.644a1.76,1.76,0,0,1,0,2.492l-5.832,5.673a.866.866,0,0,1-1.272,0l-2.333-2.28a25.806,25.806,0,0,0-35.841,0l-2.492,2.439a.866.866,0,0,1-1.272,0l-5.832-5.673a1.76,1.76,0,0,1,0-2.492l1.856-1.8Zm63.412,11.77,5.2,5.09a1.76,1.76,0,0,1,0,2.492l-23.435,22.852a1.825,1.825,0,0,1-2.545,0l-16.648-16.224a.484.484,0,0,0-.636,0l-16.648,16.224a1.825,1.825,0,0,1-2.545,0l-23.435-22.852a1.76,1.76,0,0,1,0-2.492l5.2-5.09a1.824,1.824,0,0,1,2.545,0l16.648,16.224a.484.484,0,0,0,.636,0L470.441,756.4a1.824,1.824,0,0,1,2.545,0l16.648,16.224a.484.484,0,0,0,.636,0L506.918,756.4a1.824,1.824,0,0,1,2.545,0Z",
    transform: "translate(-405.708 -695.426)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet_connect.012c74cf19db6d3e3e6790c27749f29b.svg";
export { ForwardRef as ReactComponent };